import React from 'react';

const Shopping = () => {
  return (
    <div className='content'>
      <h1>Shopping Page</h1>
      <p>this page show you products</p>
    </div>
  );
};

export default Shopping;
